<template>
  <div class="container" @click="focusInput">
    <nav-box title="在住客登记" :back="false"></nav-box>
    <div class="content flex-column">
      <div v-if="room && showCountdown" class="time">操作倒计时，{{countdownSeconds}}秒后返回</div>
      <div v-if="room" class="room-data">
        <div class="room-info">
          <div class="room-info-row">
            <div><span class="room-info-label">房间号：</span>{{room.roomNo}}</div>
          </div>
          <div class="room-info-row">
            <div><span class="room-info-label">水疗人数：</span>{{room.wqPersons}}</div>
          </div>
          <div class="room-info-row">
            <div><span class="room-info-label">在场人数：</span>{{room.count}}</div>
          </div>
          <div class="room-info-row">
            <div><span class="room-info-label">可登记人数：</span><span class="text-red">{{room.wqPersons-room.count}}</span></div>
          </div>
          <div class="room-info-row">
            <div><span class="room-info-label">客人姓名：</span>{{room.guestCname}}</div>
          </div>
          <div class="room-info-row">
            <div><span class="room-info-label">抵店时间：</span>{{room.arrDate?room.arrDate:'--'}}</div>
          </div>
        </div>
      </div>
      <div class="code-box flex-column flex-center" v-else>
        <p class="tip">请在自助机刷房卡登记手牌</p>
        <div class="code">
          <img src="../../assets/swipe.png" alt="" />
        </div>
      </div>
      
    </div>

    <div class="form" v-if="room">
      <div class="form-content" @click="handleUserOperation">

        <div class="guest-box flex-column">
          <p class="title">请选择人数</p>
          <div class="guest-sex flex-column">
            <div class="sex-item flex flex-sb">
              <div class="sex flex flex-center">
                <img src="@/assets/man.png" alt="" sizes="" srcset="" />
                <span>男宾</span>
              </div>
              <div class="num flex flex-center">
                <div class="minus flex" @click="minusNum('manQuantity')">
                  <img
                    src="@/assets/minus-icon.png"
                    v-if="manQuantity > 0"
                    alt=""
                  />
                  <img src="@/assets/minus-icon-disable.png" v-else alt="" />
                </div>
                <div class="number">
                  {{ manQuantity }}
                </div>
                <div class="add flex" @click="addNum('manQuantity')">
                  <img src="@/assets/add-icon.png" alt="" />
                </div>
              </div>
            </div>
            <div class="sex-item flex flex-sb">
              <div class="sex flex flex-center">
                <img src="@/assets/woman.png" alt="" sizes="" srcset="" />
                <span>女宾</span>
              </div>
              <div class="num flex flex-center">
                <div class="minus flex" @click="minusNum('femaleQuantity')">
                  <img
                    src="@/assets/minus-icon.png"
                    v-if="femaleQuantity > 0"
                    alt=""
                  />
                  <img src="@/assets/minus-icon-disable.png" v-else alt="" />
                </div>
                <div class="number">
                  {{ femaleQuantity }}
                </div>
                <div class="add flex" @click="addNum('femaleQuantity')">
                  <img src="@/assets/add-icon.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="btn-group flex flex-sb">
            <div class="btn-item reset flex flex-center" @click="cancel">
              取消
            </div>
            <div class="btn-item affirm flex flex-center" @click="submit">
              确认
            </div>
          </div>
        </div>

      </div>
      
    </div>


    <!-- 保存刷卡获取到的手牌号 -->
    <input type="text" ref="input" class="Key-card" focus v-model="KeyCard" @keyup.enter="swipingCard" />

  </div>
</template>

<script>
import navBox from "@/components/nav-box.vue";
import debounce from "@/utils/debounce.js";
import axios from "axios";

export default {
  components: {
    navBox,
  },
  name: "guestRegister",
  data() {
    return {
      KeyCard: "",//手牌号
      manQuantity:0,
      femaleQuantity:0,
      guestTypeId:'',//客人类型
      room:null,//在住客客房
      printRegistrOrder:1,//是否打印手牌登记单
      // hotelList:[],
      // hotelId:null,
      showCountdown:false,//是否显示倒计时
      countdownSeconds:30,//倒计时秒数
      inactivityTimer:null,//无操作定时器
      countdownTimer:null,//倒计时定时器

      isOnlyOnce:false,//自助机在住客分配手牌是否限制1张房卡只取一个手牌
      roomCardPhysicalId:null,//房卡物理ID
    };
  },
  watch: {
    KeyCard: {
      handler: function (val, oldVal) {
        this.focusInput();
      },
      deep: true,
    },
  },
  created() {

    //定时设置输入框焦点
    this.focusInputInterval = setInterval(()=>{
      if(this.room==null){
        console.log('定时设置输入框焦点')
        this.focusInput();
      }
    }, 1000*3);
  },
  destroyed() {
    //清除定时设置输入框焦点
    if(this.focusInputInterval){
      clearInterval(this.focusInputInterval);
      this.focusInputInterval = null;
    }
    //清除无操作定时器
    if(this.inactivityTimer){
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = null;
    }
    //清除倒计时定时器
    if(this.countdownTimer){
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  },
  mounted() {
    this.focusInput();
    this.getGuestType();

    //自助机在住客分配手牌是否限制1张房卡只取一个手牌
    this.getSettingCode('001003029')
    // this.getPrintRegistrOrder()
  },
  methods: {
    getSettingCode(code) {
      this.$fetchNo(this.Api.getSettingCode + "/" + code).then((res) => {

        //自助机在住客分配手牌是否限制1张房卡只取一个手牌
        if(code=='001003029'){
          this.isOnlyOnce = res.data.value == '1'?true:false;
        }
      });
    },
    //设置输入框焦点
    focusInput() {
      this.$refs.input.focus();
    },
    //启动无操作检测（5秒后显示倒计时）
    startInactivityTimer() {
      //清除之前的定时器
      this.resetTimers();
      //隐藏倒计时
      this.showCountdown = false;
      //5秒后显示倒计时
      this.inactivityTimer = setTimeout(() => {
        this.startCountdown();
      }, 5000);
    },
    //重置定时器（有操作时调用）
    resetTimers() {
      //清除无操作定时器
      if(this.inactivityTimer){
        clearTimeout(this.inactivityTimer);
        this.inactivityTimer = null;
      }
      //清除倒计时定时器
      if(this.countdownTimer){
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      //隐藏倒计时
      this.showCountdown = false;
      //重置倒计时秒数
      this.countdownSeconds = 30;
    },
    //开始30秒倒计时
    startCountdown() {
      this.showCountdown = true;
      this.countdownSeconds = 30;
      this.countdownTimer = setInterval(() => {
        this.countdownSeconds--;
        if(this.countdownSeconds <= 0){
          //倒计时结束，清空room
          this.clearRoomAndReset();
        }
      }, 1000);
    },
    //清空room并重置
    clearRoomAndReset() {
      this.resetTimers();
      this.room = null;
      this.manQuantity = 0;
      this.femaleQuantity = 0;
    },
    //处理用户操作
    handleUserOperation() {
      if(this.room){
        this.startInactivityTimer();
      }
    },
    getPrintRegistrOrder() {
      this.$fetchNo(this.Api.getSettingCode + "/001003008").then((res) => {
        this.printRegistrOrder = parseInt(res.data.value)
      });
    },
    //刷卡
    swipingCard() {
      console.log(this.KeyCard)
      if (this.KeyCard) {

        //自助机在住客分配手牌是否限制1张房卡只取一个手牌
        if(this.isOnlyOnce){
          // 检查房卡是否已登记
          this.existsRoomCardPhysicalId(this.KeyCard)
        }else{
          this.selectRoomBillByTenant()
        }
      
      }
      this.KeyCard = "";
      this.$refs.input.focus();
    },
    selectRoomBillByTenant(){
      this.$toast.loading({
        message: "正在查询，请稍后....",
        forbidClick: true,
      });

      const roomNo = (this.KeyCard.length>7?"ACCID:":"")+this.KeyCard
      this.$fetchNo(this.Api.SelectRoomBillByTenant+roomNo, {}).then((res) => {
        console.log('SelectRoomBillByTenant=',res.data)
        if(res.code==1 && res.data.length>0){
          if(res.data.length==1){
            this.$toast.clear();
            const roomList = res.data[0]
            roomList[0].count = 0
            this.room = roomList[0]

            let regIdArray = roomList.map(item => item.regId);
            this.getRoomRegisterCount(regIdArray)

            //刷卡成功后启动无操作检测
            this.startInactivityTimer();

          }else{
            // this.hotelList = res.data
            this.$toast('处理失败，存在多家门店，请联系管理人员')
          }
        }else{
          this.$toast('找不到房卡、请重刷')
        }

      }).catch(()=>{
        this.KeyCard = ''
      });
    },
    // 查询当前房卡是否已经登记过
    existsRoomCardPhysicalId(roomCardPhysicalId){
      this.$toast.loading({
        message: "正在查询，请稍后....",
        forbidClick: true,
      });
      
      //ACCID:
      this.$fetchNo(`${this.Api.ExistsRoomCardPhysicalId}${roomCardPhysicalId}`).then((res) => {
        this.$toast.clear();
        console.log(res.data)
        if(res.data==false){
          this.roomCardPhysicalId = roomCardPhysicalId
          this.KeyCard = roomCardPhysicalId;
          this.selectRoomBillByTenant()
        }else{
          this.$toast('每个房卡只能登记一个手牌，此房卡已登记')
        }
      }).catch(()=>{
        this.cancel()
      });
    },
    getRoomRegisterCount(regIdArray){
      const params = {
        regIdArray:regIdArray,
        consumptionAreaId:localStorage.getItem("consumptionAreaId")
      }

      this.$post(this.Api.RoomRegisterCount, params).then((res) => {
        if(res.data && res.data.length>0){
          console.log(res.data[0].count)
          this.room.count = res.data[0].count
          console.log('this.room=',this.room)
          console.log('this.room.count=',this.room.count)
        }
      });
    },
    // 获取客人类型列表
    getGuestType() {
      this.$fetchNo(this.Api.GuestType, { status: 1 }).then((res) => {
        const guestTypes = res.data.items.filter(item=>item.additionalProperties==16);
        if(guestTypes.length>0){
          this.guestTypeId = guestTypes[0].id
        }
      });
    },
    // 数量减法
    minusNum(item) {
      if (item == "manQuantity") {
        if (this.manQuantity == 0) {
          this.manQuantity = 0;
        } else {
          this.manQuantity--;
        }
      } else {
        if (this.femaleQuantity == 0) {
          this.femaleQuantity = 0;
        } else {
          this.femaleQuantity--;
        }
      }
    },
    // 数量加法
    addNum(item) {
      //自助机在住客分配手牌是否限制1张房卡只取一个手牌
      if(this.isOnlyOnce && (this.manQuantity+this.femaleQuantity)==1){
        this.$toast('每次只能分配一个手牌')
        return
      }

      if (item == "manQuantity") {
        this.manQuantity++;
      } else {
        this.femaleQuantity++;
      }
    },
    reset(){
      this.femaleQuantity=null;
      this.manQuantity=null
    },
    cancel(){
      this.resetTimers();
      this.femaleQuantity=0;
      this.manQuantity=0
      this.room = null
      this.roomCardPhysicalId = null
      this.KeyCard = null;
    },
    submit(){
      debounce(()=>{
        if (!this.femaleQuantity && !this.manQuantity) {
          this.$toast('请选择客人数量')
          return;
        }

        this.$toast.loading({
          message: "正在开牌中，请稍后....",
          forbidClick: true,
        });

        // 修改请求格式
        const data = {
          consumptionAreaId: localStorage.getItem("consumptionAreaId"),
          regId:this.room.regId,
          maxRegCount:this.room.wqPersons,
          roomNo:this.room.roomNo,
          roomCardPhysicalId:this.roomCardPhysicalId,
          items: [{
            femaleQuantity:this.femaleQuantity,
            manQuantity:this.manQuantity,
            guestTypeId:this.guestTypeId,
            setGuestTypeId:this.guestTypeId,
          }]
        };

        this.$post(this.Api.BatchManualOpen, data).then((res) => {
          this.$toast.clear();
          if (res.code == 1) {
            console.log(res)
            if(this.printRegistrOrder > 0){
              this.printEntrance(res.data.map(item=>({KeyNo:item.keyCardNo,consumptionSubjectId:item.consumptionSubjectId})))
            }
          }
        });
      })
    },
    // 打印入场单
    async printEntrance(list) {
      if (this.printRegistrOrder > 0) {
        //获取打印报表
        let data = {
          // id:this.orderData.id,
          //type: this.printRegistrOrder>1?"P12":"P10",
          type: "P10",
        };
        let that = this;
        let printData = await this.requestUrlOrBody(data);

        axios.post(printData.requestUrl, 
          {
            consumptionSubjectIds:list.map(item => item.consumptionSubjectId).join(","),
            keyCards:list.map(item => item.KeyNo).join(",")
          }, {
          headers: {
            access_token: this.loginToken,
            x_req_application_id: 1,
            x_req_terminal: 9,
            x_req_store_id: localStorage.getItem("storeId"),
          },
        })
        .then(function (res) {
          // 打印一张入场单
          if(that.printRegistrOrder==2){
            that.dataSet(printData.body, res.data.data);
          }else{
            console.log('printEntrance res',res)
            // 打印多张入场单
            res.data.data.dataList.forEach((item, index) => {
              setTimeout(() => {
                that.dataSet(printData.body, [item]);
              }, 3000 * index); // 每隔1.5秒执行一次

              that.cancel()
              
            });
          }
        })
        .catch(function (error) {
        });

      }
    },
    async requestUrlOrBody(data) {
      var requestData = {
        requestUrl: "",
        body: "",
      };
      let printData = await this.$fetchNo(
        this.Api.PrintReport + "/" + data.type
      );
      requestData.body = printData.data.body;
      requestData.requestUrl = printData.data.dataInterfaceUrl;
      let reportData = await this.$fetchNo(this.Api.ReportFormat, {
        reportId: printData.data.id,
      });
      if (reportData.data.items.length > 0) {
        let list = reportData.data.items.filter((item) => item.isDefault);
        if (list.length > 0) {
          requestData.body = list[0].body;
        }
      }
      return requestData;
    },
    dataSet(body, data) {
      this.load = false;
      var that = this;
      var num = data.printCount?data.printCount:0;
      var invoiceAddressValue = data.invoiceAddress?data.invoiceAddress:'';
      //创建报表对象
      var report = new window.Stimulsoft.Report.StiReport();
      // 加载文件
      report.load(body);
      //新建数据源
      var dataSet = new Stimulsoft.System.Data.DataSet("SimpleDataSet");
      //数据源填充数据
      delete data.printCount
      delete data.invoiceAddress
      dataSet.readJson(JSON.stringify(data));
      //给报表的数据源填充数据
      
      let hotelInfo = localStorage.getItem("hotelInfo") || "{}";
      hotelInfo = JSON.parse(hotelInfo);
      let storeName = hotelInfo.storeName || "云水荟";
      report.regData(dataSet.dataSetName, storeName, dataSet);
      var variableString = report.dictionary.variables.getByName("StoreName");
      variableString.value = storeName;
      if (num) {
        var printCount = report.dictionary.variables.getByName("printCount");
        printCount.value = num;
      }
      if(invoiceAddressValue){
        var invoiceAddress = report.dictionary.variables.getByName("invoiceAddress");
        invoiceAddress.value = invoiceAddressValue;
      }
      
      // report.regBusinessObject("StoreName", "酒店名称");
      // 创建报表
      viewer.report = report;
      this.loading = true;
      setTimeout(() => {
        that.loading = false;
      }, 1200);
      report.renderAsync( async function () {
        that.loading = false;
        await report.print();
      });
    },
    // clickHotel(hotelId){
    //   const roomList = this.hotelList.find(item=>item[0].hid==hotelId)
    //   this.room = roomList[0]
    //   this.room.count = 0

    //   let regIdArray = roomList.map(item => item.regId);
    //   this.getRoomRegisterCount(regIdArray)
    // }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.container {
  position: relative;
  height: 100%;
}

.content {
  align-items: center;
  justify-content: center;
  padding-top: 40px;

  .time{
    margin: 24px;
  }

  .room-data{
    background: #D9ECFF;
    width: 80%;
    padding: 24px;

    .room-info{
      background: white;
      padding: 16px;

      .room-info-row{
        display: flex;
        height: 80px;
        color: #0a1929;
        font-size: 32px;
        padding-left: 128px;

        .room-info-label{
          color: #0a1929ad;
        }
      }
    }
  }

  .code-box {
    width: 850px;
    height: 950px;
    border-radius: 24px;

    .code {
      width: 850px;
      height: 850px;
      background-color: #fff;
      margin-bottom: 90px;
      border-radius: 8px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .tip {
      font-weight: 600;
      font-size: 46px;
      color: #1A1E22;
    }
  }
}

.item {
  width: 858px;
  flex-flow: row;
  justify-content: space-around;
  margin: 8px;
}

.Key-card {
  position: absolute;
  z-index: -1;
}

.form{

  .form-content{
    padding: 48px;

    .guest-box {
      margin-top: 104px;
      width: 100%;
      .title {
        font-size: 40px;
        color: #1a1e22;
        margin-bottom: 32px;
        line-height: 50px;
        font-weight: 700;
        text-align: center;
      }
      .guest-sex {
        box-sizing: border-box;
        padding: 0 220px;
        margin-bottom: 45px;
        .sex-item {
          margin-bottom: 75px;
          .sex {
            img {
              width: 120px;
              height: 120px;
              margin-right: 16px;
            }
            span {
              font-size: 40px;
              color: #1a1e22;
              line-height: 50px;
            }
          }
          .num {
            img {
              width: 80px;
              height: 80px;
            }
            .number {
              font-size: 44px;
              color: #333333;
              font-weight: 700;
              width: 100px;
              line-height: 80px;
              text-align: center;
            }
          }
        }
      }
      .guest-type {
        width: 100%;
        box-sizing: border-box;
        padding: 0 220px;
        margin-bottom: 165px;
        select {
          width: 100%;
          height: 140px;
          background: #f4f4f4;
          box-shadow: inset 2px 4px 4px rgba(0, 0, 0, 0.25);
          border-radius: 16px;
          font-size: 44px;
          text-indent: 32px;
          color: #1a1e22;
          border: 0;
          &::placeholder {
            color: #b9bdc6;
          }
        }
      }
      .btn-group {
        width: 100%;
        box-sizing: border-box;
        padding: 0 105px;
        .btn-item {
          width: 392px;
          height: 140px;
          border-radius: 16px;
          background-color: #f4f4f4;
          font-size: 40px;
          color: #1a1e22;
          font-weight: 700;
          &.affirm {
            color: #fff;
            background-color: #155bd4;
          }
        }
      }
    }

  }

}

.text-red{
  color: red;
}
</style>